export class ProductModel {
    public id: string;
    public productCategoryId: string;
    public name: string;
    public supplierId: string;
    public description: string;
    public supplierID: string;
    public costPrice: number;
    public defaultPrice: number;
    public centreIds: string[];
    public productId: string;
    constructor() {
        this.id = null;
        this.productCategoryId = null;
        this.name = null;
        this.supplierId = null;
        this.description = '';
        this.costPrice = 0;
        this.defaultPrice = 0;
    }
    setModel(product) {
        this.id = product['id'] || null;
        this.productCategoryId = product['productCategoryId'] || null;
        this.name = product['name'] || null;
        this.supplierId = product['supplierId'] || null;
        this.description = product['description'] || '';
        this.supplierID = product['supplierID'] || '';
        this.costPrice = product['costPrice'] || 0;
        this.defaultPrice = product['defaultPrice'] || 0;
        this.productId = product['productId'] || '';
        return this;
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/models/master-data/products.model.ts